import { BusinessType } from '../../redux/auth/authTypes';
import api from '../axios/axiosInstance';

const getBusiness = async (): Promise<BusinessType> => {
  const response = await api.get(`/users/business-and-customization`);
  return response.data;
};

export default getBusiness;
